import type { FC } from "react";
import "./PreviewAvatar.css";

interface PreviewAvatarProps {
	name: string;
	subtitle?: string;
	size?: "sm" | "md" | "lg";
}

export const PreviewAvatar: FC<PreviewAvatarProps> = ({
	name,
	subtitle,
	size = "md",
}) => {
	const initials = name
		.split(" ")
		.map((n) => n[0])
		.join("")
		.slice(0, 2)
		.toUpperCase();

	return (
		<div className={`preview-avatar preview-avatar--${size}`}>
			<div className="preview-avatar__image">{initials}</div>
			<div className="preview-avatar__info">
				<span className="preview-avatar__name">{name}</span>
				{subtitle && (
					<span className="preview-avatar__subtitle">{subtitle}</span>
				)}
			</div>
		</div>
	);
};
